import { useState } from "react";
import { renderAmount } from "../../utils/formatting";
import ActionButton from "../common/action-button/ActionButton";
import InputAmountMint from "../common/input-amount/InputAmountMint";
import InputMaxButtonMint from "../common/input-max-button/InputMaxButtonMint";
import { RedemptionAction } from "./Redemption";
import { useSelector } from "../../hooks/hooks";
import { WalletAdapterName } from "../../adapters/WalletAdapter";
import { set } from "date-fns";

type Props = {
  setRedemptionAction: (action: RedemptionAction) => void;
  handleRedeem: (amount: number) => Promise<void>;
};
export default function Redeem({ setRedemptionAction, handleRedeem }: Props) {
  const connected = !!useSelector((state) =>
    state.wallet
      ? window.__UXD__.solana.config.getWalletAdapter(
          state.wallet as WalletAdapterName
        ).adapter.connected
      : false
  );

  const [amount, setAmount] = useState("");
  const [uctAmount, setUctAmount] = useState(0);
  const calculateUctAmount = (val: string) => {
    setAmount(val);
    setUctAmount(Number(val) * 1);
  };
  const UXP = window.__UXD__.solana.config.getMintInfo("UXP");

  const claimable = false;

  const toggleAction = () => {
    setRedemptionAction(RedemptionAction.Burn);
  };

  const doRedeem = async (amount: number) => {
    await handleRedeem(amount);
    setAmount("");
  };

  return (
    <>
      <div className="Redemption-Title">
        <h2>Redeem your UXP into UCT</h2>
        <p>
          UCT is a liquid token receipt that you can use to redeem into USDC
          later.
        </p>
      </div>
      <div className="Redemption-Input">
        <div className="Redemption-Content-Detail">
          <label htmlFor="amount-input">Redemption UXP</label>
          <InputMaxButtonMint
            activeMint={UXP}
            handleClick={
              !claimable
                ? (amount: string) => {
                    calculateUctAmount(amount);
                  }
                : undefined
            }
          />
        </div>

        <InputAmountMint
          id="amount-input"
          name="amount"
          amount={amount}
          handleChange={calculateUctAmount}
          disabled={false}
          reset={connected}
          mint={window.__UXD__.solana.config.getMintInfo("UXP")}
        />
        <div className="Redemption-Content-Detail">
          <div>UCT to receive</div>
          <div>{renderAmount(uctAmount, { currency: "uct", decimals: 4 })}</div>
        </div>
      </div>

      <div className="Redemption-Action">
        <ActionButton
          color="green"
          label={"Redeem"}
          disabled={!connected || !amount || Number(amount) === 0}
          form={"Redemption"}
          type="submit"
          onClick={() => doRedeem(Number(amount))}
        />
      </div>

      <div className="Redemption-Navigation">
        Burn UCT into USDC{" "}
        <a className="Redemption-Link-Burn" href="#!" onClick={toggleAction}>
          here
        </a>
        .
      </div>
    </>
  );
}
